import React from "react";
import { MdDelete } from "react-icons/md";
import { FaEye, FaFileDownload, FaFileUpload } from "react-icons/fa";
import Button from "../../../../atoms/Button";
import { ClipLoader } from "react-spinners";

const FileActions = ({ file, loading2, user, onOpenDocument, onDownloadDocument, onDeleteFile, onUploadFile }) => {
    if (file.s3Key) {
        return (
            <div className="flex flex-row space-x-4">
                <Button text={loading2? <ClipLoader color="white"/> : <FaEye size={22} />} bgColor="blue" width="w-10" onClick={() => onOpenDocument(file.s3Key, file.typeFile)} disabled={loading2} />
                <Button text={loading2? <ClipLoader color="white"/> : <FaFileDownload size={22} />} bgColor="green" width="w-10" onClick={() => onDownloadDocument(file.s3Key)} disabled={loading2} />
                {user?.role !== "Client" && (
                    <Button text={loading2? <ClipLoader color="white"/> : <MdDelete size={22} />} bgColor="red" width="w-10" onClick={() => onDeleteFile(file)} disabled={loading2} />
                )}
            </div>
        );
    } else {
        return (
            <div className="flex flex-row space-x-4">
                {user?.role !== "Client" && (
                    <Button text={<FaFileUpload size={22} />} bgColor="blue" width="w-10" onClick={() => onUploadFile(file)} disabled={loading2} />
                )}
            </div>
        );
    }
};

export default FileActions;